import $ from 'jquery';

/**
 * Check if the device is touch only
 */
export function hasTouch()
{
    // works on most browsers           // works on ie10;
    var hasTouch = !!('ontouchstart' in window) || !!('onmsgesturechange' in window);
    if(hasTouch)
    {
        var ua = navigator.userAgent;
        hasTouch = (ua.match(/Android/i) ||
        ua.match(/webOS/i) ||
        ua.match(/iPhone/i) ||
        ua.match(/iPad/i) ||
        ua.match(/iPod/i) ||
        ua.match(/BlackBerry/i) ||
        ua.match(/Windows Phone/i))?true:false;
    }
    return hasTouch;
}
/**
 * Get an item from the given array
 */
export function getItem(item, arr, prop)
{
    var i = 0,
        iL = arr.length;
    for(; i < iL; i++)
    {
        if(prop)
        {
            if(item === arr[i][prop])return arr[i];
        }
        else
        {
            if(item === arr[i])return arr[i];
        }
    }
    return null;
}
/**
 * Get items from the given array
 */
export function getItems(item, arr, prop)
{
    var i = 0,
        iL = arr.length,
        results = [];

    for(; i < iL; i++) {
        if(prop) {
            if(item === arr[i][prop]) results.push(arr[i]);
        } else {
            if(item === arr[i]) results.push( arr[i]);
        }
    }
    return results;
}
/**
 * Replace an item in a given array
 */
export function replaceItem(item, arr, prop)
{
    var i = 0,
        iL = arr.length;

    for(; i < iL; i++) {
        if(prop) {
            if(item[prop] === arr[i][prop]) arr[i] = item;
        } else {
            if(item === arr[i]) arr[i] = item;
        }
    }
    return arr;
}
/**
 * Update an item in a given array
 */
export function updateItem(item, arr, prop)
{
    var i = 0,
        iL = arr.length;

    for(; i < iL; i++) {
        if(prop) {
            if(item[prop] === arr[i][prop]) {
                arr[i] = $.extend({}, arr[i], item);
                delete arr[i].__new__;
            }
        } else {
            if(item === arr[i]) {
                arr[i] = item;
                delete arr[i].__new__;
            }
        }
    }
    return arr;
}
/**
 * Remove an item from a given array
 */
export function removeItem(item, arr, prop)
{
    var i = 0,
        iL = arr.length,
        result = [];

    for(; i < iL; i++) {
        if(prop) {
            if(item !== arr[i][prop]) result.push(arr[i]);
        } else {
            if(item !== arr[i]) result.push(arr[i]);
        }
    }
    return result;
}
/**
 * Get the x and y position based on the given event object
 * @param {Object} e
 */
export function getPosition(e)
{
    var event = e.originalEvent?e.originalEvent:e,
        pageX,
        pageY;
    if(event && event.targetTouches)
    {
        var tt = event.targetTouches[0];
        pageX = tt.clientX;
        pageY = tt.clientY;
    }
    else
    {
        pageX = e.pageX;
        pageY = e.pageY;
    }
    return {x:pageX, y:pageY};
}


/**
 * Method which searches for a property in the given object
 */
export function getObject(object, property)
{
    if (null === property || typeof property === 'undefined') {
        return null;
    }
    var prop,
        aP = property.split(".");
    if(aP.length > 0)
    {
        for(prop in object)
        {
            if(prop.toUpperCase() === aP[0].toUpperCase())
            {
                aP.shift();
                if(aP.length == 0) {
                    return object[prop];
                } else {
                    return getObject(object[prop], aP.join("."));
                }
                break;
            }
        }
    }
    return null;
}

export function uuid(){
    var d = new Date().getTime();
    if(window.performance && typeof window.performance.now === "function"){
        d += performance.now(); //use high-precision timer if available
    }
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = (d + Math.random()*16)%16 | 0;
        d = Math.floor(d/16);
        return (c=='x' ? r : (r&0x3|0x8)).toString(16);
    });
    return uuid;
}


export function queryStringToObject(queryString) {
    if (queryString[0] == '?') {
        queryString = queryString.slice(1)
    }
    var result = {};
    queryString.split('&').forEach(function(pair) {
        pair = pair.split('=');
        result[pair[0]] = decodeURIComponent(pair[1] || '');
    });

    return JSON.parse(JSON.stringify(result));
}


export function objectToQueryString(obj, prefix = null)
{
    var query = Object.keys(obj).map(function (key) {
        var value = obj[key];
        key = null !== prefix ? prefix + '[' + key + ']' : key;
        if (typeof value == 'object' || typeof value == 'array') {
            return objectToQueryString(value, key);
        }
        return key + '=' + value;
    }.bind(this));

    return query.filter(function (value) {
        return value.length > 0;
    }).join('&');
}



// WEBPACK FOOTER //
// ./src-js/Fratello/Common/Utils.jsx